/**
 * Mega Menu Products Component
 * Shows/hides pre-rendered product cards when hovering over collection links
 */

class MegaMenuProducts extends HTMLElement {
  constructor() {
    super();
    this.defaultCollection = null;
    this.baseTitle = 'Meilleures ventes';
    this.currentHandle = null;
    this.titleElement = null;
    this.productGrids = null;
  }

  connectedCallback() {
    this.defaultCollection = this.getAttribute('data-default-collection') || null;
    this.baseTitle = this.getAttribute('data-base-title') || 'Meilleures ventes';
    this.titleElement = this.querySelector('[data-title-element]');
    this.productGrids = this.querySelectorAll('[data-collection-products]');

    // Set initial title if we have a default collection
    if (this.defaultCollection) {
      const defaultLink = this.querySelector(`[data-collection-handle="${this.defaultCollection}"]`);
      if (defaultLink) {
        const collectionTitle = defaultLink.getAttribute('data-collection-title');
        this.updateTitle(collectionTitle);
      }
    }

    // Attach hover listeners to collection links
    this.attachHoverListeners();
  }

  attachHoverListeners() {
    const collectionLinks = this.querySelectorAll('[data-collection-handle]');
    
    // Update products when hovering on a collection link
    // The selection persists until hovering on a different collection
    collectionLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        const handle = link.getAttribute('data-collection-handle');
        const title = link.getAttribute('data-collection-title');
        if (handle && handle !== this.currentHandle) {
          this.showCollection(handle, title);
        }
      });
    });
  }

  showCollection(handle, collectionTitle) {
    this.currentHandle = handle;
    
    // Hide all product grids
    this.productGrids.forEach((grid) => {
      grid.hidden = true;
    });

    // Show the selected collection's products
    const targetGrid = this.querySelector(`[data-collection-products="${handle}"]`);
    if (targetGrid) {
      targetGrid.hidden = false;
    }

    // Update title
    this.updateTitle(collectionTitle);
  }

  resetToDefault() {
    if (this.currentHandle === this.defaultCollection) return;
    
    this.currentHandle = this.defaultCollection;

    // Hide all product grids
    this.productGrids.forEach((grid) => {
      grid.hidden = true;
    });

    // Show default collection's products
    if (this.defaultCollection) {
      const defaultGrid = this.querySelector(`[data-collection-products="${this.defaultCollection}"]`);
      if (defaultGrid) {
        defaultGrid.hidden = false;
      }
      
      // Get default collection title
      const defaultLink = this.querySelector(`[data-collection-handle="${this.defaultCollection}"]`);
      if (defaultLink) {
        const collectionTitle = defaultLink.getAttribute('data-collection-title');
        this.updateTitle(collectionTitle);
      } else {
        this.updateTitle(null);
      }
    } else {
      // Show fallback grid
      const fallbackGrid = this.querySelector('[data-collection-products="default"]');
      if (fallbackGrid) {
        fallbackGrid.hidden = false;
      }
      this.updateTitle(null);
    }
  }

  updateTitle(collectionTitle) {
    if (!this.titleElement) return;

    if (collectionTitle) {
      this.titleElement.textContent = `${this.baseTitle}: ${collectionTitle}`;
    } else {
      this.titleElement.textContent = this.baseTitle;
    }
  }
}

customElements.define('mega-menu-products', MegaMenuProducts);
